export interface MinimapPosition { left: number; top: number }

export function minimapPosition(x: number, y: number, worldWidth: number, worldHeight: number): MinimapPosition {
  return {
    left: Math.max(0, Math.min(100, x / worldWidth * 100)),
    top: Math.max(0, Math.min(100, y / worldHeight * 100)),
  };
}
